import { UUID } from '@/utils/uuid';
import { Timestamp, ISOCalendarDate, ISODateTimeRange } from '@/utils/date/types';
import { Entity, Specialization as CommonSpecialization, LabeledValue } from '@/types/common';

export enum ConsultationStatus {
    Unknown = '',
    AwaitingPayment = 'awaiting_payment', // Ожидание оплаты
    PaymentInProcess = 'payment_in_process', // Оплата в обработке
    Pending = 'pending', // В обработке
    Confirmed = 'confirmed', // Подтверждена
    Payed = 'payed', // Оплачена
    CanceledByAdministrator = 'cancelled_by_administrator', // Отмена администратором
    CanceledByDoctor = 'cancelled_by_doctor', // Отмена доктором
    CanceledByPatient = 'cancelled_by_patient', // Отмена пациентом
    PatientDidntCome = 'patient_didnt_come', // Пациент не пришёл
    DoctorDidntCome = 'doctor_didnt_come', // Доктор не пришёл
    Started = 'started', // Началась
    Completed = 'completed', // Завершена
    ClosedAutomatically = 'closed_automatically', // Завершена автоматически
}

export interface Symptom extends Entity{
    title: string,
    defaultIcon: string,
    activeIcon: string,
}

export interface Difficulty extends Entity{
    title: string,
}

interface Doctor extends Entity {
    city: Entity,
    clinics: Entity[],
    fullName: string,
    phone: string,
}

interface Patient extends Entity {
    birthDate: ISOCalendarDate,
    gender: LabeledValue,
    phone: string, // normalized string
    email?: string,
    new_email?: string,
}

interface Specialization extends Entity {
    title: string,
    type: {
        label: string,
        slug: string,
    },
}

interface CancellationReason extends Entity {
    title: string,
    sort: number,
}

export interface Consultation {
    createDate: string, // TODO: normalize date in the backend, it's DD.MM.YYYY now
    doctor: Doctor,
    enabledTransitions: Record<`go_to_${ConsultationStatus}`, string>,
    endTime: string, // DD.MM.YYYY hh:mm
    id: UUID,
    orderReference: string,
    patient: Patient,
    price: number,
    specialization: Specialization,
    cancellation_reason?: CancellationReason,
    startTime: string, // DD.MM.YYYY hh:mm
    status: ConsultationStatus,
    symptoms: Symptom[],
    difficulties: Difficulty[],
    difficulty_text: string,
    type: string,
    conclusionId: number,
    startedAt: string, // YYYY-MM-DDTHH:mm:ss+HH:mm
    address?: string,
    clinicAddress?: string,
    fid?: string,
    isVisitPatient: boolean,
    withVideo: boolean,
}

export interface ChatAttachment extends Entity<UUID> {
    file: File,
    timestamp: Timestamp,
}

export interface DocumentAttachment extends Entity{
    name: string,
    url: string,
}

export interface ConsultationTokens {
    channelName: string,
    rtcToken: string,
    doctorUid: string,
    doctorRtmToken: string,
    patientUid: string,
    patientRtmToken: string,
}

export interface ConsultationRequest {
    id: UUID,
    type: string,
    patient: Entity & {
        name: string,
    },
    specialization: CommonSpecialization,

    doctor: Entity & {
        value:  string,
    } | null,

    time?: ISODateTimeRange,
    duration?: number, // minutes
    price?: string,
    address?: string,
}
